export default __webpack_public_path__ + "static/media/4.329dc034.png";